export default {
    addItemModal: {
        title: 'Select Components',
    },
    button: {
        selectComponents: 'Select Component(s)',
    },
    element: {
        client_name: 'Client - Name',
        client_name_honorific: 'Client - Name + Honorific title',
        document_cost: 'Document - Total',
        document_date: 'Document - Date',
        document_number: 'Document - Number',
        document_type_en: 'Document - Type (English)',
        document_type_ja: 'Document - Type (Japanese)',
        document_type_legacy:
            'Document - Type (Legacy, see <0>Help Center</0>)',
        document_type_match: 'Document - Type (Match Template Language)',
        partner_name_en: 'Your Company - Name (English)',
        partner_name_ja: 'Your Company - Name (Japanese)',
        partner_name_match: 'Your Company - Name (Match Template Language)',
    },
    message: {
        noItem: 'At least one component must be selected.',
        success: 'PDF filename settings have been saved.',
        upgradePlan:
            'You do not have access to this feature at this plan level. See details of our plans <0>here</0> and upgrade your account.',
    },
    preview: 'Preview: ',
    section: {
        pdfFilenameClient: 'For Clients',
        pdfFilenameEmployee: 'For Users',
    },
    subTitle:
        'Select and choose the order of the components for Document PDF filenames. <0>See details</0>',
    table: {
        component: 'Component',
        order: 'Order',
    },
    title: 'PDF Filename',
    tooltip: {
        pdfFilenameClient:
            'The filename that your Clients will see when downloading documents',
        pdfFilenameEmployee:
            'The filename that you and other users will see when you download a document',
    },
};
